import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ef069b80&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=ef069b80&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef069b80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef069b80')) {
      api.createRecord('ef069b80', component.options)
    } else {
      api.reload('ef069b80', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ef069b80&scoped=true", function () {
      api.rerender('ef069b80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/modifyStoreInfo/index.vue"
export default component.exports